import { Button } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import Header from '../Header/Header';
import GenPdf from '../GenPdf';
import DocMenu from '../DocMenu';
import NumDoss from '../NumDoss';
import history from '../Routes/history';
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Add as AddIcon, PictureAsPdf as PdfIcon, Visibility as VisibilityIcon } from "@material-ui/icons";
import InformationDialog from '../InformationDialog';
import YesNoDialog from '../YesNoDialog';
import { fetchNewPropo, newNpropValue } from "../../redux/actions/devisActions";
import { changeTitleName, changePdfFileName, changeIndication } from "../../redux/actions/emailAction";
import { getDevisConHT, getDevisConTtc, getDevisReaTtc, getDevisReaHT, getDevisTabCon, getDevisTabRea, getTotalTtc, getTotalHt, numberNprop } from './Utils';
import { numberToFormat } from "../Utils";

const JSON_HEADERS = { 'Content-Type': 'application/json', 'Accept': 'application/json' };

class DevisProposition extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      file: null,
      isOpen: false,
      openDialog: false,
      openDialogAddProp: false,
      openDialogNprop: false,
      openDialogPaymentMethod: false,
      maxNprop: 0,
      paymentMethod: 0,
      disableButton: false,
      hourlyRateCon: 0,
      hourlyRateRea: 0,
      totalHtCon: 0,
      totalHtRea: 0
    }
  }

  componentDidMount() {
    this.props.dispatch(changePdfFileName(""))
    const { deviscon, dossierValue } = this.props
    if (dossierValue && deviscon) {
      this.setState({ maxNprop: numberNprop(deviscon, dossierValue), paymentMethod: 0 });
    }
  }

  componentDidUpdate(prevProps) {
    const { deviscon, dossierValue, nprop } = this.props
    if (dossierValue !== prevProps.dossierValue || nprop !== prevProps.nprop) {
      this.props.dispatch(changePdfFileName(""))
      this.setState({ maxNprop: numberNprop(deviscon, dossierValue), paymentMethod: 0, file: null });
    }
  }

  closeDoc = () => {
    this.setState({ isOpen: false })
  }

  handleGenDevis = async () => {
    const { dossierValue, nprop } = this.props
    const { paymentMethod } = this.state
    this.setState({ disableButton: true, file: null })

    try {
      await fetch("/api/devis/updateDevisPaymentMethod", {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ ndossier: dossierValue, paymentMethod })
      });

      const res = await fetch("/api/devis/genDevis", {
        // const res = await fetch("/api/devis/excelV1", {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ nprop, ndossier: dossierValue })
      });
      const blob = await res.blob();
      this.setState({ file: blob, isOpen: true });
    } catch (err) {
      console.error(err);
    }

    await this.props.dispatch(fetchNewPropo(dossierValue));
    this.props.dispatch(newNpropValue(nprop));
    this.setState({ disableButton: false });
  }

  handleNewPropo = async () => {
    const { dossierValue } = this.props;
    const { maxNprop, paymentMethod } = this.state;

    if (paymentMethod === 0) {
      this.setState({ openDialogAddProp: false, openDialogPaymentMethod: true });
      return;
    }

    try {
      const response = await fetch("/api/devis/createNewPropo", {
        method: 'POST',
        headers: JSON_HEADERS,
        body: JSON.stringify({ ndossier: dossierValue, payment_method: paymentMethod })
      });
      const result = await response.json();

      if (result) {
        await this.props.dispatch(fetchNewPropo(dossierValue));
        history.push("/devis/conception");
        this.props.dispatch(newNpropValue(maxNprop + 1));
      } else {
        this.setState({ openDialogAddProp: false, openDialogNprop: true });
      }
    } catch (error) {
      console.error(error);
    }
  }

  handleUpdateHourlyRate = async () => {
    const { dossierValue, nprop } = this.props
    const { hourlyRateCon, hourlyRateRea, totalHtCon, totalHtRea } = this.state
    this.handleClose()
    this.setState({ disableButton: true })

    try {
      await fetch("/api/devis/updateHourlyRate", {
        method: "POST",
        headers: JSON_HEADERS,
        body: JSON.stringify({ ndossier: dossierValue, nprop, hourlyRateCon, hourlyRateRea, totalHtCon, totalHtRea })
      });
    } catch (err) {
      console.error(err);
    }

    await this.props.dispatch(fetchNewPropo(dossierValue));
    this.props.dispatch(newNpropValue(nprop));
    this.setState({ disableButton: false, paymentMethod: 34 });
    await this.handleGenDevis();
  }

  handleValidateAmount = () => {
    const { devisrea, deviscon, dossierValue, nprop } = this.props
    const { paymentMethod } = this.state

    if (paymentMethod === 0) {
      this.setState({ openDialogPaymentMethod: true });
      return;
    }

    if (paymentMethod !== 34) {
      this.handleGenDevis();
      return;
    }

    const conception = getDevisConHT(deviscon, nprop, dossierValue)
    const realisation = getDevisReaHT(devisrea, nprop, dossierValue)
    const total = conception + realisation

    if ((total * 0.34).toFixed(2) === conception.toFixed(2)) {
      this.handleGenDevis();
      return;
    }

    const nbrHeuresCon = JSON.parse(getDevisTabCon(deviscon, nprop, dossierValue)).nbrHeures
    const nbrHeuresRea = JSON.parse(getDevisTabRea(devisrea, nprop, dossierValue)).nbrHeures

    const totalHCon = nbrHeuresCon.reduce((acc, heure) => acc + parseFloat(heure), 0)
    const totalHRea = nbrHeuresRea.reduce((acc, heure) => acc + parseFloat(heure), 0)

    const totalHtCon = total * 0.34
    const totalHtRea = total * 0.66

    const hourlyRateCon = parseFloat((totalHtCon / totalHCon).toFixed(4))
    const hourlyRateRea = parseFloat((totalHtRea / totalHRea).toFixed(4))

    this.setState({ hourlyRateCon, hourlyRateRea, totalHtCon, totalHtRea, openDialog: true });
  }

  handleAffDevis = async () => {
    this.setState({ file: null, disableButton: true });
    const response = await this.getFile('pdf');

    if (response?.blob.size > 100) {
      this.setState({ file: response.blob, isOpen: true });
      this.props.dispatch(changePdfFileName(response.fileName));
    }
    this.setState({ disableButton: false });
  }

  handleGetPdfFile = async () => {
    this.setState({ file: null });
    const response = await this.getFile('pdf');

    if (response?.blob.size > 100) {
      this.setState({ file: response.blob });
      this.props.dispatch(changePdfFileName(response.fileName));
    }
  }

  handleGetWordFile = async () => {
    this.setState({ file: null });
    const response = await this.getFile('word');

    if (response?.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      this.setState({ file: response.blob });
      this.props.dispatch(changePdfFileName(response.fileName));
    }
  }

  getFile = async (type) => {
    try {
      const res = await fetch("/api/devis/getDevisFile", {
        method: "POST",
        headers: JSON_HEADERS,
        body: JSON.stringify({ ndossier: this.props.dossierValue, nprop: this.props.nprop, type })
      });
      const blob = await res.blob();
      const fileName = res.headers.get('X-FileName');
      return { blob, fileName };
    } catch (err) {
      console.error(err);
      return null;
    }
  }

  handleClose = () => {
    this.setState({ openDialog: false });
  }

  handleCloseAddProp = () => {
    this.setState({ openDialogAddProp: false });
  }

  handleCloseNprop = () => {
    this.setState({ openDialogNprop: false });
  }

  handleClosePaymentMethod = () => {
    this.setState({ openDialogPaymentMethod: false });
  }

  devisPage = () => {
    history.push("/devis/conception");
  }

  handleChangeTitleName = () => {
    this.props.dispatch(changeTitleName("Proposition de Devis"))
  }

  render() {
    const { deviscon, devisrea, nprop, dossierValue } = this.props
    const { file, paymentMethod, disableButton, openDialog, openDialogAddProp, openDialogNprop, openDialogPaymentMethod, isOpen, maxNprop } = this.state

    return (
      <div className="devisProp">
        <Header />
        <DocMenu
          file={file}
          getSourceFile={this.handleGetWordFile}
          getPDF={this.handleGetPdfFile}
          handleChangeTitleName={this.handleChangeTitleName}
          updateIndication={() => this.props.dispatch(changeIndication(this.props.nprop))}
        />
        <div className="devis-payment">
          <NumDoss type="devis" />
          <div>
            <label>Type de paiement : </label>
            <select
              onChange={(event) => this.setState({ paymentMethod: parseInt(event.target.value) })}
              value={paymentMethod}
            >
              <option value={0}>{""}</option>
              <option value={26}>26%</option>
              <option value={34}>34%</option>
            </select>
          </div>
        </div>

        <h1 className="title">
          <div className="titl">Proposition de Devis</div>
        </h1>

        <div className="tabDev">
          <div className="tabDevHeader">Récapitulatif financier</div>
          <table className="customTable">
            <thead>
              <tr>
                <th></th>
                <th>Montant EUR / HT</th>
                <th>Montant EUR / TTC</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Phase de conception</td>
                <td>{numberToFormat(getDevisConHT(deviscon, nprop, dossierValue))}</td>
                <td>{numberToFormat(getDevisConTtc(deviscon, nprop, dossierValue))}</td>
              </tr>
              <tr>
                <td>Phase de réalisation</td>
                <td>{numberToFormat(getDevisReaHT(devisrea, nprop, dossierValue))}</td>
                <td>{numberToFormat(getDevisReaTtc(devisrea, nprop, dossierValue))}</td>
              </tr>
              <tr>
                <td><span>Total</span></td>
                <td><span>{numberToFormat(getTotalHt(devisrea, deviscon, nprop, dossierValue))}</span></td>
                <td><span>{numberToFormat(getTotalTtc(devisrea, deviscon, nprop, dossierValue))}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="btn-group">
          {disableButton && <CircularProgress className="spinner" color="inherit" />}
          <Button className='btn-create' variant="contained" color="primary" startIcon={<AddIcon />} onClick={() => this.setState({ openDialogAddProp: true })} disabled={disableButton}>Nouvelle Proposition</Button>
          <Button variant="contained" color="primary" startIcon={<PdfIcon />} onClick={this.handleValidateAmount} disabled={disableButton}>Générer</Button>
          <Button variant="contained" color="primary" startIcon={<VisibilityIcon />} onClick={this.handleAffDevis} disabled={disableButton}>Afficher</Button>
        </div>
        <GenPdf isOpen={isOpen} file={file} closeDoc={this.closeDoc} scale={file !== null ? 1.5 : 0.5} />
        <InformationDialog
          isOpen={openDialogNprop}
          title={'INFORMATION'}
          information={'Vous ne pouvez pas créer plus de 3 nouvelles propositions après avoir valider un devis'}
          handleClose={this.handleCloseNprop}
        />
        <InformationDialog
          isOpen={openDialogPaymentMethod}
          title={'INFORMATION'}
          information={'Veuillez choisir un type de paiment'}
          handleClose={this.handleClosePaymentMethod}
        />
        <YesNoDialog
          isOpen={openDialogAddProp}
          title={'CREER UNE NOUVELLE PROPOSITION'}
          question={`Êtes-vous sûr de vouloir créer une nouvelle proposition N°${maxNprop + 1} pour le dossier ${dossierValue}`}
          handleYesClick={this.handleNewPropo}
          handleClose={this.handleCloseAddProp}
        />
        <Dialog open={openDialog} onClose={this.handleClose}>
          <DialogTitle>ERREUR CALCUL DE DEVIS</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Le montant alloué à la phase de conception ne correspond pas à 34% du montant total.
              Comment vous souhaitez ajuster le calcul ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={this.devisPage} style={{ color: "white", backgroundColor: "#FF7F50" }}>
              Manuellement
            </Button>
            <Button variant="contained" onClick={this.handleUpdateHourlyRate} style={{ color: "white", backgroundColor: "green" }}>
              Automatiquement
            </Button>
            <Button variant="contained" onClick={this.handleClose} style={{ color: "white", backgroundColor: "#F5B039" }}>
              Annuler
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  devisrea: state.devis.devisrea,
  deviscon: state.devis.deviscon,
  dossierValue: state.devis.dossierValue,
  nprop: state.devis.nprop,
});

export default connect(mapStateToProps)(DevisProposition)
